import * as React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { Divider } from '@components/Divider';

import { useNewPdDesignEnabled } from '../hooks/useNewPdDesignEnabled';
import { Clear } from '../styled';

import { Container, MarginWrapper, Title } from './styled';

export interface ISectionContainerProps {
  titleMessage?: MessageDescriptor;
  titleId?: string;
  containerId?: string;
  listLabel?: string;
  withDivider?: boolean;
  children: React.ReactNode;
}

export const SectionContainer = React.forwardRef<
  HTMLDivElement,
  ISectionContainerProps
>(({ containerId, withDivider, titleId, titleMessage, children }, ref) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();
  return (
    <>
      <Container
        id={containerId}
        key={containerId}
        withDivider={withDivider}
        newPdDesignEnabled={newPdDesignEnabled}
      >
        <MarginWrapper ref={ref} newPdDesignEnabled={newPdDesignEnabled}>
          {withDivider && <Divider newPdDesignEnabled={newPdDesignEnabled} />}

          {Boolean(titleMessage) && (
            <Title id={titleId} newPdDesignEnabled={newPdDesignEnabled}>
              <FormattedMessage {...titleMessage} />
            </Title>
          )}

          {children}
        </MarginWrapper>
      </Container>

      <Clear />
    </>
  );
});
